export const sortByName = (list) => {
    let listSorted = list.sort((itemA, itemB) => {
        let nameA = "";
        let nameB = "";

        if (!itemA.name && !itemB.name) {
            nameA = itemA.Name.toLowerCase();
            nameB = itemB.Name.toLowerCase();
        } else { // Delete content Else statement after MVC deprecation is completed
            nameA = itemA.name.toLowerCase();
            nameB = itemB.name.toLowerCase();
        }

        if (nameA < nameB) {
            return -1;
        }
        else if (nameA > nameB) {
            return 1;
        }
        else {
            return 0;
        }
    })
    return listSorted;
}

export const selectProjectNameDropdownData = (projects) => {
    if (projects.length <= 0) return [];

    let formattedProjectData = [];
    projects.forEach(({ Name, Id, id, name }) => {
        if (Name && Id && Name.length > 0) {
            formattedProjectData.push({
                id: Id,
                name: Name
            });
        } else {
            formattedProjectData.push({
                id: id,
                name: name
            });
        }
    });

    formattedProjectData = sortByName(formattedProjectData);
    return [...formattedProjectData];
}

export const selectProjectMemberNameDropdownData = (projects) => {
    if (projects.length <= 0) return [];

    let formattedMemberData = [];
    let duplicateProjectMemberDict = {};

    projects.forEach(({ members, Members, Groups }) => {
        let projectMembers = members;

        if (!projectMembers || projectMembers == null) {
            projectMembers = [
                ...(Members || []),
                ...(Groups?.map(group => ({
                    ...group,  
                    User: {
                        ...group.User, 
                        Id: parseInt(`9900${group.Id}`) // appending 9900 to the group.Id and converting to int (this is how its being sent for the old groups from backend)
                    }
                })) || [])
            ];

            if (!projectMembers) return;

            projectMembers.forEach((member) => {
                if (!(member.User.Id in duplicateProjectMemberDict)) {
                    duplicateProjectMemberDict[member.User.Id] = true;

                    formattedMemberData.push({
                        name: member.User.Name,
                        //UserNameFull: member.User.Name,
                        id: member.User.Id,
                        //UserId: member.User.Id
                    });
                }
            })
        } else { // Delete content Else statement after MVC deprecation is completed
            if (!projectMembers) return;

            projectMembers.forEach((member) => {
                if (!(member.userID in duplicateProjectMemberDict)) {
                    duplicateProjectMemberDict[member.userID] = true;

                    formattedMemberData.push({
                        name: member.userNameFull,
                        userNameFull: member.userNameFull,
                        id: member.userID,
                        userID: member.userID
                    });
                }
            })
        }
    })

    formattedMemberData = sortByName(formattedMemberData);
    return [...formattedMemberData];
}

export const selectTagDropdownData = (projects) => {
    if (projects.length <= 0) return [];

    let formattedTagData = [];
    let duplicateTagDict = {};

    projects.forEach(({ tags, Tags }) => {
        let projectTags = tags;

        if (!projectTags || projectTags == null) {
            projectTags = Tags;

            if (!projectTags) return;

            projectTags.forEach((tag, index) => {
                if (!(tag in duplicateTagDict)) {
                    duplicateTagDict[tag] = true;

                    formattedTagData.push({
                        name: tag,
                        id: index
                    });
                }
            });
        } else { // Delete content Else statement after MVC deprecation is completed
            if (!projectTags) return;

            projectTags.forEach((tag, index) => {
                if (!(tag in duplicateTagDict)) {
                    duplicateTagDict[tag] = true;

                    formattedTagData.push({
                        name: tag,
                        id: index
                    });
                }
            });
        }
    });

    formattedTagData = sortByName(formattedTagData);
    return [...formattedTagData];
}
